import Provider from './atom/provider';
import PopinEnd from './template/app-player/popin-end';
import PopinCorrection from './template/app-player/popin-correction';
import Player from './template/app-player/player';
import Loading from './template/app-player/loading';
import PopinNoAccess from './template/app-player/popin-no-access';

export {Provider, PopinEnd, PopinCorrection, Loading, Player, PopinNoAccess};
